import {connect, MapDispatchToPropsObject} from 'react-redux';
import {PRAMP} from '../../../common/constants';
import {registerUser as register} from '../../../redux/modules/sign-up/actions';
import {ISignUpUdacityConnected, IStore} from './types';
import {getFirstAllowedErrorMessage, getErrorMessage} from '../service';
import {AuthSignUpUdacity as Container} from './sign-up-udacity';

const mapStateToProps = ({signUp}: IStore): ISignUpUdacityConnected => ({
  firstNameError: getErrorMessage('firstName', signUp.provider, signUp.errors),
  lastNameError: getErrorMessage('lastName', signUp.provider, signUp.errors),
  passwordError: getErrorMessage('password', signUp.provider, signUp.errors),
  prampError: signUp.provider === PRAMP && getFirstAllowedErrorMessage(signUp.errors),
  isLoading: signUp.isLoading,
});

const mapDispatchToProps: MapDispatchToPropsObject = {
  register,
};

export const AuthSignUpUdacity = connect(mapStateToProps, mapDispatchToProps)(Container);
